export const MODAL_NEWS_RVP_SESSION_KEY = 'disabled-products-without-rvp';

export const MODAL_NEWS_RVP_BANNER_SRC = '/img/modal-news-rvp/banner.svg';

export const MODAL_NEWS_RVP_ENDPOINTS = {
  activate: '/products-without-rvp/activate',
  deny: '/products-without-rvp/deny'
} as const;

export const MODAL_NEWS_RVP_TEXTS = {
  title: 'Ative a recuperação de vendas',
  subtitle: 'Temos uma ferramenta poderosa e totalmente gratuita para você aproveitar!',
  benefits: ['Recupera vendas não finalizadas', 'Aumenta sua conversão em até 15%', 'Funciona sem esforço'],
  callToAction: 'Que tal ativar agora?',
  autoActivationNotice:
    'Se preferir esperar, ela será ativada automaticamente nos seus produtos elegíveis em até 7 dias.',
  denyButton: 'Agora não',
  activateButton: 'Ativar agora',
  closeLabel: 'Fechar',
  activateSuccess: 'Ativação realizada com sucesso!',
  activateError: 'Não foi possível ativar a recuperação de vendas.',
  denySuccess: 'Preferência registrada.',
  denyError: 'Não foi possível registrar sua escolha.'
} as const;
